// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  waveId: __t.u64().primaryKey().name("wave_id"),
  fromIdentity: __t.identity().name("from_identity"),
  toIdentity: __t.identity().name("to_identity"),
  boosted: __t.bool(),
  at: __t.timestamp(),
});
